import React from 'react';
import {
  Modal,
  Button,
} from 'antd';
import { SpText } from 'components/DesignKit';

type Props = {
  confirmInvoiceLineItemModalVisibility: Boolean,
  setConfirmInvoiceLineItemModalVisibility: Function,
  showInvoiceDetailGid: String,
  history: {
    push: Function,
  },
  setAuditEvent: Function,
  status: String,
  setStatus: Function,
};

const DisplayImportantMessage = (props: Props) => {
  const {
    confirmInvoiceLineItemModalVisibility,
    setConfirmInvoiceLineItemModalVisibility,
    showInvoiceDetailGid,
    history,
    setAuditEvent,
    status,
    setStatus,
  } = props;

  const handleConfirmInvoiceLineItemModalCancel = () => {
    setConfirmInvoiceLineItemModalVisibility(false);
  };

  const handleConfirmInvoiceLineItemModalSave = () => {
    setConfirmInvoiceLineItemModalVisibility(false);
    if (showInvoiceDetailGid) {
      if (status === 'Ready to Process') {
        setAuditEvent({
          gid: showInvoiceDetailGid,
          payload: {
            eventHeader: 'Review Started',
            eventOrigin: null,
          },
        });
        setStatus(null);
      }
      history.push(`/lynxconnect/invoices/validate/${showInvoiceDetailGid}`);
    }
  };

  return (
    <Modal
      title="Important Message"
      visible={confirmInvoiceLineItemModalVisibility}
      onCancel={handleConfirmInvoiceLineItemModalCancel}
      footer={[
        <Button key="ok" type="primary" onClick={handleConfirmInvoiceLineItemModalSave}>
          OK
        </Button>,
      ]}
      centered
      maskClosable={false}
      closable
    >
      <div style={{ padding: '20px' }}>
        <SpText style={{ fontWeight: 'bolder', display: 'block', marginBottom: '12px' }}>
          We’ve found new barcodes on the physical invoice that need your attention.
        </SpText>
        <SpText style={{ fontWeight: 'bolder', display: 'block', marginBottom: '12px' }}>
          <b>What you can do:</b>
          <ol>
            <li style={{ marginBottom: '10px' }}>
              <b>Correct any errors:</b>
              If you spot an error, update the barcode and click icon to sync the item with your existing list.
            </li>
            <li style={{ marginBottom: '10px' }}>
              <b>Link to an existing product:</b>
              If the barcode belongs to an existing product in your inventory,
              associate the new barcode using the product code and click to update it.
            </li>
            <li style={{ marginBottom: '10px' }}>
              <b>Add new items to inventory:</b>
              To add these new items to your inventory, simply Export the list and update your inventory records accordingly.
            </li>
          </ol>
        </SpText>
      </div>
    </Modal>
  );
};

export default DisplayImportantMessage;
